import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export function CustomDatePicker({
  value,
  onChange,
  label,
  mode = "datetime",
  disabled = false,
  readOnly = false,
  required = false,
  labelFontSize = "0.9rem",
  inputFontSize = "0.8rem",
  size = "small",
  variant = "filled",
  error = false,
  helperText = "",
  ...props
}) {
  const Picker = mode === "date" ? DatePicker : DateTimePicker;
  const isOutlined = variant === "outlined";

  return (
    <Picker
      label={label}
      value={value ? (mode === "date" ? dayjs(value) : dayjs.utc(value).local()) : null}
      onChange={(newValue) => {
        if (!newValue || !newValue.isValid()) {
          onChange?.("");
          return;
        }

        if (mode === "date") {
          onChange?.(newValue.format("YYYY-MM-DD"));
        } else {
          onChange?.(newValue.toISOString());
        }
      }}
      disabled={disabled}
      readOnly={readOnly}
      slots={{
        openPickerIcon: CalendarTodayOutlinedIcon,
      }}
      slotProps={{
        openPickerIcon: {
          sx: {
            fontSize: "1rem",
          },
        },
        textField: {
          fullWidth: true,
          required,
          size,
          variant,
          error: Boolean(error),
          helperText,
          InputLabelProps: {
            shrink: true,
          },
          sx: {
            "& .MuiInputLabel-root": {
              fontSize: labelFontSize,
            },
            ...(isOutlined && {
              "& .MuiOutlinedInput-notchedOutline legend": {
                fontSize: `calc(${labelFontSize} * 0.75)`,
              },
            }),
          },
          slotProps: {
            input: {
              ...(isOutlined && { notched: true }),
              sx: {
                ...(!isOutlined && { fontSize: inputFontSize }),
                pr: 1.4,
              },
            },
          },
        },
      }}
      {...props}
    />
  );
}
